export default __webpack_public_path__ + "static/media/B130.d26a64f2.png";